import { render, staticRenderFns } from "./ProgramCanvas.vue?vue&type=template&id=197ea1ac&scoped=true"
import script from "./ProgramCanvas.vue?vue&type=script&lang=js"
export * from "./ProgramCanvas.vue?vue&type=script&lang=js"
import style0 from "./ProgramCanvas.vue?vue&type=style&index=0&id=197ea1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ea1ac",
  null
  
)

export default component.exports